module.exports = __webpack_public_path__ + "static/media/10.ace8d254.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/10.png
// module id = 1050
// module chunks = 0